export var textStylesValues = ['title1', 'title2', 'title3', 'heading1', 'heading2', 'heading3', 'heading4', 'heading5', 'heading6', 'article', 'paragraph', 'caption', 'overline', 'disclaimer', 'highlight', 'subtitle1', 'subheading1', 'subheading2', 'subheading3', 'subheading4', 'subheading5', 'subheading6'];
var textStylesAllowedPropsAcc = {
  fontSize: [],
  fontWeight: [],
  lineHeight: [],
  letterSpacing: [],
  caps: []
};
export function typographyAttrs(props) {
  var textStyle = props.textStyle,
      theme = props.theme;

  if (!textStyle) {
    return {};
  }

  if (Array.isArray(textStyle)) {
    var styles = textStyle.map(function (style) {
      return theme.typography[style];
    });
    return styles.reduce(function (acc, style) {
      var styleProps = Object.keys(style);
      styleProps.forEach(function (styleProp) {
        var stylePropValue = style[styleProp] || null;

        if (styleProp && stylePropValue) {
          acc[styleProp].push(stylePropValue);
        } else {
          acc[styleProp].push(null);
        }
      });
      return acc;
    }, textStylesAllowedPropsAcc);
  } else {
    return theme.typography[textStyle];
  }
}